import { useFetcher } from '@/modules/dataFetcher'
import { Row, Col } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { appointmentData, serviceFetcher } from './modules'
import { SearchItemContent, StyledRepairs, RepairPrice } from '../repairs/SearchRepairs'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import ModelInfo from '../repairs/Modelnfo'
import BrandInfo from '../repairs/BrandInfo'
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg"
import SectionHeader from '../common/SectionHeader'
const StyledTitle = styled.span`
    font-weight: bold;
    font-size: 20px;
    line-height: 16px;
    /* identical to box height, or 24px */

    /* Neutrals/700 */
    color: #404040;
`

const StyledAppointmentOverview = styled(Row)`
    display: flex;
    .mragain-section-title span {
        color: #404040;
    }
    margin-top: 16px;
    .brand-info {
        min-width:100%;
    }
    @media (max-width: 420px) {
       margin-top: 0px;
       .model-info {
            margin-top: 26px;
       }
       .brand-info {
            margin-top: 26px;
        }
    }    

    @media (min-width: 768px) {
        .appointment-overview-content {
            margin-top: 22px;
            border: 1px solid #C0C0C0;
            border-radius: 8px;
            padding: 16px;
        }
    }
`

const StyledBox = styled.div`
`
const StyledRepair = styled.div`
    border-top: 1px solid #DDDDDD;
    // border: 2px solid var(--primary-main-color);
    // border-radius: 8px;
    margin-top: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    .search-data-name {
        color: #404040;
        font-size:18px;
        margin: 0;
    }
    .search-data-price{
        background-color: #fff;
        
    }
    .search-data-price-value, .search-data-gurarantee, .search-data-currency{
        color: var(--primary-main-color);
    }
    .repair-close {
        display: flex;
        min-width: 64px;
        min-height: 64px;
        justify-content: center;
        align-items: center;
        @media (max-width: 420px) {
            min-width: 30px;
            min-height: 64px;
        }    
    }
    .price-on-request {
        display:flex;
        justify-content: center;
        align-items: center;
    }
    .price-on-request .search-data-price-value {
        text-align: center;
    }

`



const repairInfo = createSelector(
    state => state,
    state => state.appointment?.params || {},
    state => state.searchData?.step,
    (state, params, selectRepairStep) => {
        const shopId = params.shop?.id
        const deviceId = params.device
        const brandId = params.brand
        const modelId = params.model
        const repairId = params.reparation
        const deviceGuid = `appoitment~device~${shopId}~${deviceId}`
        const brandGuid = `appoitment~brand~${shopId}~${deviceId}~${brandId}`
        const modelGuid = `appoitment~model~${shopId}~${deviceId}~${brandId}~${modelId}`
        const serviceGuid = `appoitment~service~${shopId}~${deviceId}~${brandId}~${modelId}~${repairId}`
        // console.log(params)
        // console.log(deviceGuid)
        return {
            rdevice: state.fetcher?.[deviceGuid]?.result,
            rbrand: state.fetcher?.[brandGuid]?.result,
            rmodel: state.fetcher?.[modelGuid]?.result,
            rrepair: state.fetcher?.[serviceGuid]?.result,
            selectRepairStep,
        }
    }

)

const Repair = ({ item }) => {
    // console.log(item)
    return <Row type="flex" align="start" className="search-data-details" gutter={16} style={{ justifySelf: "center" }}>
        <Col>
            <StyledBox className='repair-close'> <CloseIcon /> </StyledBox>
            {/* <StyledBox className='search-data-guarantee'>{item.result.guarantee_time} minuten</StyledBox> */}
        </Col>
        <Col style={{ flexGrow: "1" }}>
            <Row type="flex" justify="space-between" align="middle" className="search-data-details" gutter={0} style={{ justifySelf: "center" }}>
                <Col style={{ maxWidth: "75%" }}>
                    <StyledBox className='search-data-name'>{item.name}</StyledBox>
                </Col>
                <Col span={6} style={{ alignSelf: 'center', justifySelf: 'center' }}>
                    {/* <StyledBox className="search-data-price">
                        <StyledBox className='search-data-currency'>€</StyledBox>
                        <StyledBox className='search-data-price-value'>{item.result.price}</StyledBox>
                    </StyledBox> */}
                    <RepairPrice repair={item}/>
                </Col>
            </Row>
        </Col>
    </Row>

}

const AppointmentOverview = ({ }) => {
    const { rrepair, rbrand, rmodel } = useSelector(repairInfo)
    const [repair, setRepair] = useState()
    useEffect(() => {
        // console.log(rdevice, rbrand, rmodel, rrepair)
        if (rrepair) {
            setRepair(
                {
                    name: rrepair.reparation?.reparation_name,
                    image: rrepair.reparation?.repair_image,
                    result: {
                        price: rrepair.price,
                        guarantee_time: rrepair.guarantee_time,
                    }
                }
            )
        } else {
            setRepair(null)
        }
    }, [rrepair])
    return <StyledAppointmentOverview className="appointment-overview">
        <Row type="flex" gutter={0} style={{minWidth: '100%'}}>
            <Col span={24}>
                <SectionHeader title="Reparatie Lijst" style={{ color: "#404040" }} />
            </Col>
            <Col span={24} className="appointment-overview-content">
                <Row>
                    <Col span={24}>
                        {rmodel? <ModelInfo selector={repairInfo} /> : <BrandInfo selector={repairInfo} />}
                    </Col>
                    {repair && <Col span={24}>
                        <StyledRepairs>
                            <StyledRepair >
                                <Repair item={repair} />
                            </StyledRepair>
                        </StyledRepairs>
                    </Col>
                    }

                </Row>

            </Col>
        </Row>

    </StyledAppointmentOverview>
}

export default AppointmentOverview;
export { repairInfo }